import React, { useMemo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Form from '@rjsf/core';
import { Spinner, Box } from '@thecb/components';
import styled from 'styled-components';
import { fetchDenominationsRequest } from '../../state/shared';
import { defaultValidator } from '../../utils/json-schema-validator/validator';

const DenominationContainer = styled(Box)`
  // override rjsf/core styles
  > * {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  input {
    width: 150px;
    margin-bottom: 12px;
  }
  input:last-of-type {
    margin-bottom: 0px;
  }
  label {
    font-weight: normal;
  }
`;

function ObjectFieldTemplate(props) {
  // solely for styling purposes
  return (
    <DenominationContainer padding="16px 0px 0px 16px">
      {props.properties.map((element) => {
        return element.content;
      })}
    </DenominationContainer>
  );
}

export const DynamicDenominationsFieldGroup = ({
  denominationsFormState,
  setDenominationsFormState,
}) => {
  const { isLoading, denominations } = useSelector((state) => state.shared);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!denominations.length) {
      dispatch(fetchDenominationsRequest());
    }
  }, []);
  const handleChange = (e) => {
    setDenominationsFormState(e.formData);
  };
  const denominationsJsonSchema = useMemo(
    () => ({
      type: 'object',
      properties: denominations.reduce((acc, cur) => {
        acc[cur.name] = {
          title: cur.formattedValue,
          type: 'number',
          quantity: 0,
          denomination_id: cur.id,
        };
        return acc;
      }, {}),
    }),
    [denominations],
  );
  return (
    <>
      {isLoading ? (
        <Spinner size="100" />
      ) : (
        <Form
          formData={denominationsFormState}
          onChange={handleChange}
          schema={denominationsJsonSchema}
          validator={defaultValidator}
          ObjectFieldTemplate={ObjectFieldTemplate}
        >
          <React.Fragment />
        </Form>
      )}
    </>
  );
};
